var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    opacity: 0
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#979797",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-16",
    transform: "translate(12.103448, 10.241379)",
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "1.68447414 8.31306724 0.299560345 8.31306724 0.299560345 0.124665517 8.52199138 0.124665517 8.52199138 8.34630517 5.6255431 8.34630517"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.29018276,
    cy: 8.34630517,
    r: 1.49491552
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.5118224,
    cy: 8.34630517,
    r: 1.49491552
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "9.26905345 2.3666431 12.9529241 2.3666431 14.5008621 5.06524655 14.5008621 9.09336724 13.5171776 9.09336724"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.7475924,6.57022565 C17.2698158,3.31783257 13.9928865,1.05617844 10.1877195,1.05617844 C4.99780648,1.05617844 0.790550673,5.26343425 0.790550673,10.4533473 C0.790550673,14.6307273 3.51630505,18.1714732 7.28627322,19.3940446 C8.20005589,19.6903772 9.17518648,19.8505162 10.1877195,19.8505162",
    id: "Oval-3",
    stroke: "#1557bf",
    strokeWidth: 2,
    transform: "translate(9.769072, 10.453347) rotate(4.000000) translate(-9.769072, -10.453347) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    stroke: "#1557bf",
    points: "6.16088986 10.8575288 9.59732793 10.8575288 9.59732793 5.1558227"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreorder);
export default __webpack_public_path__ + "static/media/preorder.8d0e807679736dba2234797459f812f6.svg";
export { ForwardRef as ReactComponent };